import React from 'react';
import PropTypes from 'prop-types';
import { Oval } from 'react-loader-spinner';
import './Spinner.scss';

const Spinner = ({ color, secondaryColor, height, width }) => (
    <div className="loading">
        <Oval color={color} secondaryColor={secondaryColor} height={height} width={width} />
    </div>
);

Spinner.defaultProps = {
    color: '#434758',
    secondaryColor: '#3b3b3b',
    height: '80',
    width: '80',
};

Spinner.propTypes = {
    color: PropTypes.string,
    secondaryColor: PropTypes.string,
    height: PropTypes.string,
    width: PropTypes.string,
};

export default Spinner;
